import { useEffect } from 'react';
import { useUnreadCount } from './UnreadCountContext';

const UnreadCountBooter = ({ user }) => {
  const { setNotificationUnread } = useUnreadCount();

  useEffect(() => {
    if (user?.isLogged && user.token) {
      fetch(process.env.REACT_APP_SERVER_URL + '/notify/unread-count', {
        headers: { Authorization: 'Bearer ' + user.token},
      })
        .then((res) => res.json())
        .then((count) => {
          setNotificationUnread(Number(count) || 0);
        })
        .catch(() => {
          setNotificationUnread(0);
        });
    } else {
      setNotificationUnread(0);
    }
  }, [user?.isLogged, user?.token, setNotificationUnread]);

  return null;
};

export default UnreadCountBooter;
